var map = {
	"./InCasino.svg": 376,
	"./InLottery.svg": 377,
	"./InPoker.svg": 378,
	"./InRNG.svg": 379,
	"./InSlots.svg": 380,
	"./InSports.svg": 381,
	"./InVirtual-Sports.svg": 382,
	"./IneSports.svg": 383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;